import React from 'react';
import { Button, Typography, Grid } from 'antd';
import { FileAddOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Paragraph } = Typography;
const { useBreakpoint } = Grid;

export default function TemplateUploadCTA({ onNewTemplate }) {
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const isMobile = screens.xs;
  return (
    <div style={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
        <Button
          icon={<FileAddOutlined />}
          onClick={onNewTemplate}
          size={isMobile ? 'large' : 'default'}
        >
          {isMobile ? t('note_templates.create_from_file_mobile') : t('note_templates.create_from_file')}
        </Button>
      </div>
    </div>
  );
}


